import type { Location as HistoryLocation } from 'history';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useRouteProps } from 'src/common/providers/RoutePropsProvider';
import { screenViewTracker } from '../../client/analytics';
import { grantFacebookPixelConsent } from '../../client/analytics/facebook/fbTrack';
import { processGTagEvents } from '../../client/analytics/vendorScripts/loadGTag';
import useLotame from './useLotame';
import useOnConsentReady from './useOnConsentReady';
import useOnMount from './useOnMount';

interface UseClientAnalyticsProps {
  onHistoryUpdate: (location: HistoryLocation) => void;
  hasNonAdEligibleOverlay: boolean;
}

export default function useClientAnalytics({
  onHistoryUpdate,
  hasNonAdEligibleOverlay,
}: UseClientAnalyticsProps) {
  const history = useHistory();
  const routeProps = useRouteProps();

  useOnMount(() => history.listen(onHistoryUpdate));
  useLotame();
  useOnConsentReady((gdprApplies: boolean, isOptedOutOfTargeting?: boolean) => {
    if (gdprApplies && isOptedOutOfTargeting === false) {
      grantFacebookPixelConsent();
    }

    if (!gdprApplies) {
      processGTagEvents();
    }
  });
  useEffect(() => {
    screenViewTracker.onRouteChange(routeProps, hasNonAdEligibleOverlay);
  }, [routeProps, hasNonAdEligibleOverlay]);
}
